import { ListOption } from './../../../../../models/listOption';
import {
  Component,
  OnInit,
  Input,
  ComponentFactoryResolver,
  ChangeDetectorRef
} from '@angular/core';
import {
  ListDataEntity,
  ControlType,
  DataSourceCodes
} from 'src/app/models/data-entities';
import { DataEntityInputComponent } from '../../data-entity-input/data-entity-input.component';
import { FormGroup, FormControl } from '@angular/forms';
import { CommonDropdownData } from 'src/app/components/common/common-dropdown/common-dropdown.component.model';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
  selector: 'wm-list-data-entity-input',
  templateUrl: './list-data-entity-input.component.html',
  styleUrls: ['./list-data-entity-input.component.css'],
  standalone: false
})
export class ListDataEntityInputComponent extends DataEntityInputComponent
  implements OnInit {
  @Input() entity: ListDataEntity;
  @Input() showLabel = true;
  @Input() orientation: 'horizontal' | 'vertical' = 'vertical';
  commonDropdownData!: CommonDropdownData;

  selectedEntityValues: ListOption[];
  listEntity: ListDataEntity;
  selectedDropdownItemId: string = '';
  legacyList = false;
  //added by furkan 16-12-2025
  templateForPermitForm: boolean = false;
  //end by furkan 16-12-2025
   selectedMap: Record<number, boolean> = {};
  // Local FormGroup for non-legacy checkbox lists in the permit-form template.
  // Kept as a component-local field rather than being registered on the shared
  // parent form so that two ListDataEntity instances that happen to share the
  // same `templateCode` do not collide on `<templateCode>_checkboxes`
  // (FormGroup.addControl is a no-op when the key already exists, which caused
  // "Cannot find control with name: <listItemId>" for the second instance).
  private _checkboxGroup: FormGroup | null = null;
  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, ref: ChangeDetectorRef, context : WorkflowContextService) {
    super(layoutService, componentFactoryResolver, ref, context);
    //added by furkan 16-12-2025
     layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
    //end by furkan 16-12-2025
  }

  ngOnInit() {
    this.selectedEntityValues = [];

    this.listEntity = this.entity;

    if (
      this.listEntity.availableListItems.some(ali => !ali.id) ||
      DataSourceCodes.DYNAMIC_ID_LIST_CODES.includes(
        this.listEntity.selectedDataSource
      )
    ) {
      this.legacyList = true;
    } else {
      this.legacyList = false;
    }

    if (this.entity.controlType === ControlType.Check && !this.legacyList) {
      this.listEntity.availableListItems.forEach(item => {
        const controlName = `${this.entity.templateCode}_${item.id}`;

        if (!this.form.contains(controlName)) {
          this.form.addControl(
            controlName,
            new FormControl(this.isSelected(item))
          );
        }

        this.form.controls[controlName].valueChanges.subscribe(checked => {
          this.addItem(checked, item);
        });
      });
    }

    if (this.entity.controlType === ControlType.Check && this.legacyList) {
      this.listEntity.availableListItems.forEach(item => {
        const controlName = `${this.entity.templateCode}_${item.value}`;

        if (!this.form.contains(controlName)) {
          this.form.addControl(
            controlName,
            new FormControl(this.isLegacyItemSelected(item))
          );
        }

        this.form.controls[controlName].valueChanges.subscribe(checked => {
          this.addLegacyItem(checked, item.value);
        });
      });
    }
    if (this.legacyList) {
      this.listEntity.selectedValues.forEach(e => this.addLegacyItem(true, e));
    } else {
      this.listEntity.selectedValues.forEach(e => this.addItem(true, e));
    }
    if (
      !this.entity.externalDataSource ||
      !this.entity.externalDataSource.sourceConfig ||
      (this.entity.canEditExternalValue &&
        this.form.controls[this.entity.templateCode])
    ) {
      this.form.controls[this.entity.templateCode].enable();
    } else {
      this.form.controls[this.entity.templateCode].disable();
    }
    // //radio selection default
    // if (
    //   this.entity.controlType === ControlType.Radio &&
    //   this.form.contains(this.entity.templateCode)
    // ) {
    //   const control = this.form.get(this.entity.templateCode);

    //   if (
    //     (control?.value === null || control?.value === '') &&
    //     this.listEntity?.availableListItems?.length
    //   ) {
    //     control.setValue(this.listEntity.availableListItems[0].id);
    //   }
    // }

    this.getCommonDropdownData();

    // Always build the checkbox FormGroup for checkbox lists so that the
    // permit-form template's `[formGroup]="checkboxGroup"` /
    // `[formControlName]="ali.id"` bindings can resolve at any point after
    // ngOnInit. `layoutService.useNewLayout$` is a BehaviorSubject that starts
    // false and may flip to true asynchronously; if we only built the group
    // when it was already true at ngOnInit, later template renders would find
    // `checkboxGroup === null` and throw "Cannot find control with name: <ali.id>".
    if (this.entity.controlType === ControlType.Check && !this.legacyList) {
      this.buildCheckboxControls();
    }
  }

  get checkboxGroup(): FormGroup {
    return this._checkboxGroup;
  }

  buildCheckboxControls(): void {
    // Build a component-local FormGroup: { [itemId]: boolean }.
    // Not registered on the shared parent form on purpose — see the comment on
    // `_checkboxGroup` above. The parent `<templateCode>` control still holds
    // the serialized JSON selection and is what gets persisted.
    const group: Record<string, FormControl> = {};

    this.listEntity.availableListItems.forEach(item => {
      group[item.id] = new FormControl(this.isItemSelected(this.listEntity, item));
    });

    const checkboxGroup = new FormGroup(group);
    this._checkboxGroup = checkboxGroup;

    // Sync to parent JSON control on any change
    checkboxGroup.valueChanges.subscribe((values: Record<string, boolean>) => {
      this.selectedEntityValues = this.listEntity.availableListItems
        .filter(item => values[item.id])
        .map(item => {
          const copy = { ...item };
          delete copy['$id'];
          return copy;
        });

      const jsonValue = this.selectedEntityValues.length > 0
        ? JSON.stringify(this.selectedEntityValues)
        : '[]';

      this.listEntity.value = jsonValue;

      const control = this.form.get(this.entity.templateCode);
      if (control) {
        control.setValue(
          this.selectedEntityValues.length > 0 ? jsonValue : '',
          { emitEvent: false }  // prevent infinite loop
        );
        control.updateValueAndValidity();
      }
    });
  }

  addItem(checked: boolean, item: any) {
    if (!item || item === '') {
      // don't do anything if there is no item
      return;
    }

    this.listEntity.value = '';

    let listItem = this.listEntity.availableListItems.find(
      a => a.id === item.id
    );

    // if selected item is not in the list, add it
    if (!listItem) {
      listItem = item;
      this.listEntity.listTextValues.push(listItem);
    }

    if (this.entity.controlType === ControlType.Check) {
      if (checked === false) {
        // Remove item by id instead of by index to avoid issues
        this.selectedEntityValues = this.selectedEntityValues.filter(
          v => v.id !== item.id
        );
      } else {
        // Check if item already exists before pushing
        const alreadyExists = this.selectedEntityValues.some(
          v => v.id === item.id
        );
        if (!alreadyExists) {
          this.selectedEntityValues.push(listItem);
        }
      }
    } else {
      this.selectedEntityValues = [];
      this.selectedEntityValues.push(listItem);
    }

    if (this.entity.controlType === ControlType.Dropdown) {
      this.selectedDropdownItemId = listItem.id;
    }

    // remove all of the $id attributes before serializing
    this.selectedEntityValues.forEach(f => delete f['$id']);

    this.listEntity.value = JSON.stringify(this.selectedEntityValues);

    if (this.listEntity.controlType !== ControlType.Dropdown) {
      if (this.listEntity.value === '[]') {
        this.form.controls[this.entity.templateCode].setValue('');
      } else {
        this.form.controls[this.entity.templateCode].setValue(
          this.listEntity.value
        );
      }
    } else {
      this.form.controls[this.entity.templateCode].setValue(listItem.value);
    }
  }

  addItemById(checked: boolean, itemId: string) {
    let listItem = this.listEntity.availableListItems.find(
      a => a.id === itemId
    );

    this.addItem(checked, listItem);
  }

  isSelected(item: any): boolean {
    const selected = !!this.selectedEntityValues.find(
      v => v && v.id === item.id
    );

    return selected;
  }

  /*
    We don't want to interfere with migrated list data
    entities that we created without giving ids to its ListItems
  */

  addLegacyItem(checked: boolean, value: any) {
    if (!value) {
      // don't do anything if the value is an empty string...
      return;
    }
    this.listEntity.value = '';

    if (typeof value !== 'string') {
      value = value.value;
    }

    let listItem = this.listEntity.availableListItems.find(
      a => a.value === value
    );

    // if selected item is not in the list, add it
    if (!listItem) {
      listItem = value;
      this.listEntity.listTextValues.push(listItem);
    }

    if (this.entity.controlType === ControlType.Check) {
      if (checked === false) {
        // Remove legacy item by value comparison
        this.selectedEntityValues = this.selectedEntityValues.filter(
          v => !(v === value || (v && v.value === value))
        );
      } else {
        // Check if legacy item already exists before pushing
        const alreadyExists = this.selectedEntityValues.some(
          v => v === value || (v && v.value === value)
        );
        if (!alreadyExists) {
          this.selectedEntityValues.push(listItem);
        }
      }
    } else {
      this.selectedEntityValues = [];
      this.selectedEntityValues.push(listItem);
    }

    // remove all of the $id attributes before serializing
    this.selectedEntityValues.forEach(f => delete f['$id']);
    this.listEntity.value = JSON.stringify(this.selectedEntityValues);

    if (this.listEntity.controlType !== ControlType.Dropdown) {
      if (this.listEntity.value === '[]') {
        this.form.controls[this.entity.templateCode].setValue('');
      } else {
        this.form.controls[this.entity.templateCode].setValue(
          this.listEntity.value
        );
      }
    } else {
      this.form.controls[this.entity.templateCode].setValue(listItem.value);
    }
  }

  isLegacyItemSelected(value: any): boolean {
    const selected = !!this.selectedEntityValues.find(
      v =>
        v &&
        (v === value.id ||
          v === value.value ||
          v.value === value.value ||
          v.value === value.id)
    );

    return selected;
  }

  //added by furkan 16-12-2025
  getCommonDropdownData() {
    let currentId = null;

    try {
      if (this.listEntity.value && this.listEntity.value.startsWith('[')) {
        const parsed = JSON.parse(this.listEntity.value);
        if (parsed.length > 0) {
          currentId = parsed[0].value;
        }
      } else {
        currentId = this.listEntity.value;
      }
    } catch (e) {
      currentId = this.listEntity.value;
    }
    return (this.commonDropdownData = {
      placeholder: 'Select Item...',
      options: (this.listEntity?.availableListItems || []).map(a => ({
        label: a.text,
        value: a.value
      })),
      required: this.entity.isRequired,
      selectedValue: currentId || null,
      style: {
        width: '100%',
        panelBg: '#ffffff'
      }
    });
  }

  getLegacyCommonDropdownData() {
    return {
      placeholder: 'Select Item...',
      options: (this.listEntity?.availableListItems || []).map(a => ({
        label: a.text,
        value: a.value
      })),
      selectedValue: this.selectedDropdownItemId || null,
      style: {
        width: '100%'
      }
    };
  }

  onCommonDropdownChange(val: string | number | null) {
    if (val === null || val === undefined || val === '') {
      return;
    }
    this.selectedDropdownItemId = String(val);
    this.addItemById(true, String(val));

    // const control = this.form.get(this.entity.templateCode);
    // console.log('Control: ', control);
    // control.markAsPristine();
    // control.markAsUntouched();
    // control.updateValueAndValidity();
  }

  onLegacyCommonDropdownChange(val: string | number | null) {
    if (val === null || val === undefined || val === '') {
      return;
    }
    this.selectedDropdownItemId = String(val);
    this.addLegacyItem(true, val);
  }

  onCheckboxToggle(checked: boolean, item: ListOption): void {
    if (!item) return;

    if (!this.selectedEntityValues) {
      this.selectedEntityValues = [];
    }

    if (checked) {
      const exists = this.selectedEntityValues.some(v => v.id === item.id);
      if (!exists) {
        const itemToStore = { ...item };
        delete itemToStore['$id'];
        this.selectedEntityValues.push(itemToStore);
      }
    } else {
      this.selectedEntityValues = this.selectedEntityValues.filter(
        v => v.id !== item.id
      );
    }

    const jsonValue =
      this.selectedEntityValues.length > 0
        ? JSON.stringify(this.selectedEntityValues)
        : '[]';

    this.listEntity.value = jsonValue;

    const control = this.form.get(this.entity.templateCode);
    if (control) {
      const formValue = this.selectedEntityValues.length > 0 ? jsonValue : '';

      control.setValue(formValue);

      control.updateValueAndValidity();
    }
  }

  isItemSelected(entity: ListDataEntity, item: ListOption): boolean {
    if (
      !this.selectedEntityValues ||
      !Array.isArray(this.selectedEntityValues)
    ) {
      return false;
    }
    return this.selectedEntityValues.some(selected => selected.id === item.id);
  }

  getCommonRadioData() {
    let currentId = null;

    try {
      if (this.listEntity.value && this.listEntity.value.startsWith('[')) {
        const parsed = JSON.parse(this.listEntity.value);
        if (parsed.length > 0) {
          currentId = parsed[0].value;
        }
      } else {
        currentId = this.listEntity.value;
      }
    } catch (e) {
      currentId = this.listEntity.value;
    }
    if (!this.entity.isVisible) {
      currentId = null;
    }

    return {
      options: (this.listEntity?.availableListItems ?? []).map(a => ({
        label: a.text,
        value: a.value,
        disabled: (a as any)?.disabled ?? false
      })),
      required: this.entity.isRequired,
      value: currentId,
      direction: 'column'
    };
  }

  handleRadioChange(newValue: any, entity: any): void {
    const selectedItem = this.listEntity?.availableListItems?.find(
      item => item.id === newValue || item.value === newValue
    );

    if (selectedItem) {
      const itemToStore = { ...selectedItem }; 
      this.selectedEntityValues = [itemToStore];
      this.listEntity.value = JSON.stringify(this.selectedEntityValues);
      if (this.form.controls[this.entity.templateCode]) {
        this.form.controls[this.entity.templateCode].setValue(
          this.listEntity.value
        );
      }
    } else {
      this.selectedEntityValues = [];
      this.listEntity.value = '[]';
    }
  }

  handleDropdownChange(newValue: any, entity: any): void {
    // Clearing the dropdown -> reset selection state.
    if (newValue === null || newValue === undefined || newValue === '') {
      this.selectedEntityValues = [];
      this.listEntity.value = '[]';
      this.selectedDropdownItemId = null;
      return;
    }

    // Match by value first (wm-common-dropdown emits the option's `value`),
    // then fall back to id for robustness.
    const listItem = this.listEntity?.availableListItems?.find(
      item => item.value === newValue || item.id === newValue
    );

    if (!listItem) {
      // Unknown value - store raw so at least entity.value reflects the form control.
      entity.value = newValue;
      return;
    }

    // Mirror the legacy addItem() dropdown path so ListDataEntity.getFormulaValue
    // (which JSON.parses this.value and reads selectedValues[0].value) works
    // correctly for criteria/visibility evaluation.
    const itemToStore: any = { ...listItem };
    delete itemToStore['$id'];
    this.selectedEntityValues = [itemToStore];
    this.listEntity.value = JSON.stringify(this.selectedEntityValues);
    this.selectedDropdownItemId = listItem.id;
  }

  getLegacyCommonRadioData() {
    return {
      options: (this.listEntity?.availableListItems || []).map(a => ({
        label: a.text,
        value: a.value,
        disabled: (a as any).disabled || false // Type assertion to handle missing property
      })),
      value:
        this.selectedEntityValues && this.selectedEntityValues.length > 0
          ? this.selectedEntityValues[0].id ||
            this.selectedEntityValues[0].value
          : null,
      direction: 'column'
    };
  }

  onCommonRadioChange(val: any) {
    if (val === null || val === undefined || val === '') {
      return;
    }

    // find selected item by id and reuse existing addItem path
    const listItem = this.listEntity.availableListItems.find(a => a.id === val);
    if (listItem) {
      this.addItem(true, listItem);
    } else {
      // fallback for safety: if not found by id, treat as legacy value
      this.addLegacyItem(true, val);
    }
  }

  onLegacyCommonRadioChange(val: any) {
    if (val === null || val === undefined || val === '') {
      return;
    }
    // value for legacy lists is the 'value' field
    this.addLegacyItem(true, val);
  }

  onCommonCheckboxChange(checked: boolean, item: any) {
    // delegate to existing function
    this.addItem(checked, item);
  }

  onLegacyCommonCheckboxChange(checked: boolean, value: any) {
    this.addLegacyItem(checked, value);
  }

  // Helper method to get disabled state with type safety
  getItemDisabled(item: any): boolean {
    return (item as any).disabled || false;
  }
  //ended by furkan 16-12-2025
}
